<template>
  <div>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li v-for="(item, index) in reservations.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
      </ul>
    </nav>
    <b-table small
      :fields="tableHead"
      :items="reservations.data"
      responsive="sm">
      <!-- A custom formatted column -->
      <template #cell(created_at)="data">
        {{ $moment(data.item.created_at).format('YYYY-MM-DD HH:mm') }}
      </template>
      <!-- A custom formatted column -->
      <template #cell(total)="data">
        {{ numberFormat(data.item.total) }} {{ data.item.currency }}
      </template>
      <template #cell(service_type)="data">
        {{ data.item.service_type }} <br>
        <span>{{ $moment(data.item.arrival_date).format('YYYY-MM-DD HH:mm') }}</span>
        <br>
        <span v-if="data.item.service_type == 'round trip'">{{ $moment(data.item.departure_date).format('YYYY-MM-DD HH:mm') }}</span>
      </template>
      <template #cell(base_total)="data">
        {{ numberFormat(data.item.base_total) }} {{ data.item.currency }}
      </template>
      <template #cell(quota)="data">
        <a href="#" @click.prevent="openModalQuota(data.item)">{{ numberFormat(data.item.quota) }} {{ data.item.currency }} <font-awesome-icon :icon="['fas', 'edit']"/></a>
      </template>
      <template #cell(commission)="data">
        {{ numberFormat(getCommission(data.item)) }} {{ data.item.currency }}
      </template>
      <template #cell(status)="data">
        <b-badge v-if="data.item.status == 'completed'" variant="success">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status == 'cancelled'" variant="danger">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status == 'in_process'" variant="info">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status == 'pending'" variant="light">{{data.item.status}}</b-badge>
      </template>
      <template #cell(options)="data">
        <b-button size="sm" :href="urlReservation(data.item)" variant="outline-primary">
          <font-awesome-icon :icon="['fas', 'edit']"/>
        </b-button>
        <b-button size="sm" :href="urlPrintReservation(data.item)" target="_blank" variant="primary">
          <font-awesome-icon :icon="['fas', 'print']"/>
        </b-button>
      </template>
    </b-table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li v-for="(item, index) in reservations.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
      </ul>
    </nav>
    <b-modal v-if="selectedItem" v-model="modalQuota" id="bv-modal-example" hide-footer>
      <template #modal-title>
        Cambiar cuota para la reservacion #{{selectedItem.id}}
      </template>
      <div class="d-block">
        <b-form @submit.prevent="updateQuota">
          <Loading :active="loading" :full-page="true"></Loading>
          <label class="mr-sm-2" for="select-quota">Cuota</label>
          <b-form-select
            v-model="quotaform"
            id="select-quota"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="quotas()"
            :value="null"
          ></b-form-select>
          <b-alert v-if="errors" v-model="showErrors" dismissible variant="danger" class="mt-3">
            <ul class="m-0">
              <template v-for="field in errors">
                <li v-for="(m, index) in field" :key="index" class="text-danger">{{ m }}</li>
              </template>
            </ul>
          </b-alert>
          <b-alert v-model="updateSuccess" dismissible variant="success" class="mt-3">
            La reservación se actualizo correctamente
          </b-alert>
          <b-button type="submit" variant="primary" class="mt-3">Guardar</b-button>
        </b-form>
      </div>
      <!-- <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button> -->
    </b-modal>
  </div>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import {NumberFormat} from "../../helpers/NumberFormat"
  export default {
    name: 'ReservationsSeller',
    props:['reservations'],
    components: {FontAwesomeIcon},
    data() {
      return {
        errors:null,
        loading:false,
        modalQuota:false,
        showErrors: false,
        selectedItem:null,
        updateSuccess: null,
        quotaform:null,
        //quotas:[{text:"4", value: 4.0},{text:"5", value: 5.0},{text:"6", value: 6.0}],
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'created_at', label: 'Creada' },
          { key: 'folio', label: 'Folio' },
          { key: 'customer_name', label: 'Cliente' },
          { key: 'status', label: 'Status' },
          { key: 'service_type', label: 'Servicio' },
          { key: 'service_name', label: 'Producto' },
          { key: 'pax', label: 'Pax' },
          { key: 'total', label: 'Total' },
          { key: 'base_total', label: 'B.Total' },
          { key: 'quota', label: 'Cuota' },
          { key: 'commission', label: 'Comisión' },
          { key: 'payment_type', label: 'Pago' },
          { key: 'options', label: 'Acciones' },
        ]
      }
    },
    methods:{
      quotas () {
        const exchange = this.selectedItem.exchange_dollar
        return [
          {text:NumberFormat.round(4 / exchange, 2) +this.selectedItem.currency + '->4 usd', value: NumberFormat.round(4 / exchange, 2)},
          {text:NumberFormat.round(5 / exchange, 2) +this.selectedItem.currency + '->5 usd', value: NumberFormat.round(5 / exchange, 2)},
          {text:NumberFormat.round(6 / exchange, 2) +this.selectedItem.currency + '->6 usd', value: NumberFormat.round(6 / exchange, 2)}
        ]
      },
      openModalQuota(r) {
        this.modalQuota = true
        this.selectedItem = r
        this.quotaform = NumberFormat.round(parseFloat(r.quota), 2)
      },
      urlPrintReservation(item) {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
        return url+'/'+item.id+'/print-ticket'
      },
      numberFormat(num) {      
        let n = num || 0 
        return NumberFormat.format(parseFloat(n), 2, ',', '.')
      },
      urlReservation(item) {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
        return url+'/'+item.id
      },
      getCommission(reservation) {
        return parseFloat(reservation.total) - (parseFloat(reservation.base_total) + parseFloat(reservation.quota))
      },
      updateQuota() {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations/${this.selectedItem.id}/update-quota`
        this.loading = true
        this.showErrors = false
        this.$axios.post(url, {id:this.selectedItem.id, quota:this.quotaform}).then(rs => {
          this.updateSuccess = true
          //this.updateHistory = !this.updateHistory
          this.selectedItem.quota = this.quotaform
          this.loading = false
        })
        .catch(error=> {
          this.showErrors = true
          if (error.response) {
            this.errors = error.response.data.errors
          }  else {
            this.errors = {
              unexpected: ['Hubo un error por favor contacte al administrador']
            }
          }
          console.log('error update', error);
          this.loading = false
        })
      }
    },
    /*computed:{
      quotas () {
        const exchange = selectedItem.exchange
        return [
          {text:80 / , value: 4.0},
          {text:100, value: 5.0},
          {text:120, value: 6.0}
        ]
      }
    }*/
  }
</script>